module.exports = __webpack_public_path__ + "static/media/p6.4aa04676.pdf";